import './ui/styles.css';
import { Game } from './Game';
import { UI } from './ui/UI';

/**
 * Giriş noktası.
 * Kritik hatalarda beyaz ekran bırakmak yerine kullanıcıya anlaşılır bir mesaj gösterilir.
 */

function fatal(message: string, detail?: unknown): void {
  console.error('[KG]', message, detail);
  const root = document.getElementById('kg-ui');
  if (!root) return;
  root.innerHTML = `
    <div class="screen active">
      <h1 style="letter-spacing:4px">HATA</h1>
      <p class="hint">${message}</p>
      <p class="hint" style="opacity:.6;font-size:12px">${detail ? String(detail).slice(0, 300) : ''}</p>
      <button class="btn primary" onclick="location.reload()">YENİDEN DENE</button>
    </div>`;
}

function boot(): void {
  const canvas = document.getElementById('kg-canvas') as HTMLCanvasElement | null;
  const uiRoot = document.getElementById('kg-ui');
  if (!canvas || !uiRoot) {
    fatal('Sayfa yapısı eksik (canvas veya UI kökü bulunamadı).');
    return;
  }

  // WebGL desteği kontrolü: cihaz desteklemiyorsa net mesaj
  try {
    const test = document.createElement('canvas');
    const gl = test.getContext('webgl2') ?? test.getContext('webgl');
    if (!gl) {
      fatal('Bu cihaz/tarayıcı WebGL desteklemiyor. Güncel bir tarayıcı deneyin.');
      return;
    }
  } catch (err) {
    fatal('Grafik başlatılamadı.', err);
    return;
  }

  let game: Game;
  try {
    game = new Game(canvas);
    const ui = new UI(game, uiRoot);
    // Test/otomasyon UI akışlarını da sürebilsin (envanter/onarım gibi).
    (window as unknown as { KG_UI: UI }).KG_UI = ui;
    game.start();
  } catch (err) {
    fatal('Oyun başlatılamadı.', err);
    return;
  }

  // Tarayıcı autoplay politikası: AudioContext yalnızca ilk kullanıcı
  // etkileşiminde (tık/dokunma/tuş) başlatılabilir.
  const wake = () => game.audio.resume();
  window.addEventListener('pointerdown', wake, { passive: true });
  window.addEventListener('keydown', wake);
  window.addEventListener('touchstart', wake, { passive: true });

  // Sekme kapanırken / arka plana geçerken kaydet
  const flush = () => {
    if (game.state === 'playing' || game.state === 'paused') game.flushOnExit();
  };
  window.addEventListener('beforeunload', flush);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) flush();
  });

  // Yakalanmayan hatalar: oyun döngüsünü öldürmeden bildir
  window.addEventListener('error', (e) => console.error('[KG] hata:', e.error ?? e.message));
  window.addEventListener('unhandledrejection', (e) => console.error('[KG] promise hatası:', e.reason));

  // Geliştirici erişimi (test harness'ı bunu kullanır)
  (window as unknown as { KG: Game }).KG = game;
  // Hangi bundle'ın çalıştığı konsoldan da doğrulanabilir olsun.
  (window as unknown as { KG_BUILD: string }).KG_BUILD = __KG_BUILD__;
  console.info(`[KG] build ${__KG_BUILD__}`);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
